import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "@cloudscape-design/global-styles/index.css";

import { Amplify } from 'aws-amplify';

// Config resolution — dual-mode so this SAME branch works for both:
//  - Gen 2 (WEB_COMPUTE) apps (e.g. CTA dev): the backend phase (ampx
//    pipeline-deploy) generates amplify_outputs.json; amplify.yml copies it into
//    src/, and we use it (this env's pool / Hosted-UI / AppSync / redirects).
//  - Legacy prod WEB app (frontend-only, no backend phase): no generated config,
//    so src/amplify_outputs.json stays the committed {"_placeholder": true}
//    marker and we fall back to the known prod config below.
import outputs from './amplify_outputs.json';

// The placeholder path used to fall back to a hardcoded Gen 1 configuration
// (us-east-1_87ui2TECl and an us-east-1 AppSync endpoint). Gen 1 was decommissioned on
// 2026-09-02, so that fallback pointed at resources which no longer exist: it would have
// produced an opaque auth failure rather than a useful error. Fail loudly instead.
if (outputs && outputs._placeholder) {
  throw new Error(
    'amplify_outputs.json is the committed placeholder. Generate real outputs before ' +
    'building: `npx ampx generate outputs --app-id <id> --branch <branch>`. ' +
    'The previous hardcoded fallback referenced Gen 1 resources that were deleted.'
  );
}

Amplify.configure(outputs);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
